//https://docs.videojs.com/
(function($, d, w) {

    w.addEventListener(w.ZP_DEFAULT.ZP_EVENT_DOM_READY, onInit);

    function onInit()  {
        const elements = $('.zp_video');
        if(elements.length > 0) {
            elements.each((index, element) => {
                new Video($(element));
            });
        }
    }

    class Video {

        constructor (root) {

            this.root = root;

            //DATA
            this.DATA = {
                autoplay: this.root.data('auto-play') === 1,
                infinityPlay: this.root.data('infinity-play') === 1,
                controlBar: this.root.data('hide-control-bar') !== 1,
                controls: this.root.data('disable-control') !== 1,
                fluid: this.root.data('fluid') === 1 && _.isUndefined(this.root.data('aspect-ratio')),
                aspectRatio: this.root.data('aspect-ratio')
            };

            this.init();
        }

        init () {

            this.initVideoJs();

        }

        initVideoJs () {

            // console.log(this.DATA.fluid);
            // console.log(this.DATA.aspectRatio);

            let self = this;
            this.video = videojs(this.root.context.id+'-video', {
                autoplay: this.DATA.autoplay,
                muted: this.DATA.autoplay, //TODO: Chrome-Bug, muted muss true sein, wenn autoplay verwendet wird
                controls: this.DATA.controls,
                controlBar: this.DATA.controlBar,
                loop: this.DATA.infinityPlay,
                aspectRatio: this.DATA.aspectRatio,
                fluid: this.DATA.fluid,
                responsive: true
            }, function () {

                this.on('play', () => {
                    // console.log('play');
                    // console.log(self.hasStarted());
                });

                //TODO: Eleganter lösen
                //Fallback, falls Autoplay anfangs nicht funktioniert
                if (self.DATA.autoplay) {
                    setTimeout(() => {
                        if (!self.hasStarted()) {
                            this.play();
                        }
                    }, 1000)
                }

            });

            // this.video.play();
            // console.log(this.DATA)
            // console.log(this.video)

            // if (this.DATA.autoplay) {
            //
            //     this.video.ready(() => {
            //
            //         this.video.currentTime(0);
            //
            //         let promise = this.video.play();
            //
            //         if (promise !== undefined) {
            //             promise.then(function() {
            //                 console.log('START!!!')
            //                 // Autoplay started!
            //             }).catch(function(error) {
            //                 console.log('ERROR!!!')
            //                 // Autoplay was prevented.
            //             });
            //         }
            //
            //     });
            //
            // }

        }

        hasStarted () {

            return this.root.find('.video').hasClass('vjs-has-started');
        }

    }

})(jQuery, document, window);